import {makeGetRefundBeneficiaries} from 'main/factories/usecases';

export const getRefundBeneficiaries = async (signal?: AbortSignal) => {
	const data = await makeGetRefundBeneficiaries().get({signal});
	return data?.content?.beneficiaries;
};
